module.exports = __webpack_public_path__ + "img/dribbble-btn.09cac1f4.svg";